import axios from 'axios'

// 统一字典获取
export function getDict(params) {
  return new Promise((resolve, reject) => {
    let data = [];
    axios.get(`/web/bbs/common/dictbytype.json`, {
      params: {
        type: params
      }
    }).then(res => {
      if (res.data.code == 'v') {
        data = res.data.tdata;
      }
      resolve(data)
    }).catch(() => {
      resolve(data)
    })
  })
}

// 通用匹配字典方法
export function matchDict(dictList, diccode) {
  let result = dictList.filter((item) => {
    return item.diccode == diccode
  })
  return result.length > 0 ? result[0].dicname : ''
}

